import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, Users, Lock, ArrowLeft, ArrowRight } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { FreeBadge } from '../LockedDialog';
import { CAT_ICONS } from '../articles/articleUtils';

export const LEVEL_STYLES = {
  beginner: 'bg-emerald-100 text-emerald-700',
  intermediate: 'bg-amber-100 text-amber-700',
  advanced: 'bg-rose-100 text-rose-700',
};

export const QuizCard = ({ quiz, levelLabel, getLabel, locked, index }) => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  const Icon = CAT_ICONS[quiz.category] || HelpCircle;
  return (
    <div className="art-reveal flex" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}>
    <Link to={`/quizzes/${quiz.id}`} data-testid={`quiz-card-${quiz.id}`} style={{ '--glow': '#10b981' }}
      className="plan-glow group w-full flex flex-col bg-white rounded-2xl border border-slate-200/80 p-6 shadow-sm outline-none">
      <div className="flex items-start justify-between gap-3 mb-5">
        <span className="w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-400 to-green-600 text-white flex items-center justify-center shadow-lg shadow-emerald-500/25 group-hover:scale-110 transition-transform">
          <Icon className="w-7 h-7" />
        </span>
        <div className="flex items-center gap-1.5">
          {quiz.is_free && <FreeBadge />}
          {locked && <span className="w-8 h-8 rounded-full bg-amber-400 flex items-center justify-center"><Lock className="w-4 h-4 text-slate-900" /></span>}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <span data-testid={`quiz-level-${quiz.id}`} className={`px-2.5 py-1 rounded-lg text-xs font-bold ${LEVEL_STYLES[quiz.level]}`}>{levelLabel}</span>
        <span className="px-2.5 py-1 rounded-lg text-xs font-bold bg-blue-50 text-blue-700">{getLabel(quiz.category, lang)}</span>
      </div>
      <h3 className="text-slate-900 font-extrabold text-lg leading-snug mb-2 line-clamp-2">{lang === 'ar' ? quiz.titleAr : (quiz.titleEn || quiz.titleAr)}</h3>
      <p className="text-slate-500 text-sm leading-relaxed line-clamp-2 mb-5 flex-1">{lang === 'ar' ? quiz.descAr : (quiz.descEn || quiz.descAr)}</p>
      <div className="flex items-center gap-4 text-xs text-slate-500 pt-4 border-t border-slate-100 mb-4">
        <span className="inline-flex items-center gap-1.5"><HelpCircle className="w-4 h-4 text-emerald-500" />{quiz.question_count} {L('سؤال', 'questions')}</span>
        <span className="inline-flex items-center gap-1.5"><Users className="w-4 h-4 text-blue-500" />{quiz.attempts || 0} {L('محاولة', 'attempts')}</span>
      </div>
      <span className="inline-flex items-center gap-1.5 text-emerald-600 font-bold text-sm">{L('ابدأ الاختبار', 'Start quiz')}<Arrow className="w-4 h-4" /></span>
    </Link>
    </div>
  );
};
